import styled from 'styled-components';
export const DialogClose = styled.button `
  unset: all;
  border: none;
  background: none;
  outline: none;
  margin: 0;
`;
